import { render } from "./logo-menu-templates.vue?vue&type=template&id=b3b25b22&scoped=true"
const script = {}

import "./logo-menu-templates.vue?vue&type=style&index=0&id=b3b25b22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3b25b22"]])

export default __exports__